<template>
  <div class="timeCell-box">
    <van-cell-group>
      <van-cell
        v-for="item in list"
        :key="item.id"
        :title="item.noon | noon"
        :label="item.startTime"
        is-link
        center
        @click="toQueren(item)"
      >
        <template #icon>
          <!-- <van-icon name="search" class="search-icon" /> -->
          <div class="item-status">{{ item.keepQuota ? '可预约' : '已约满' }}</div>
        </template>
        <span slot="default">余号:{{ item.keepQuota }}&emsp;&emsp;￥{{ item.registerMoney }}</span>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'TimeCell',
  filters: {
    noon: (val) => {
      switch (val) {
        case '1':
          return '上午'
        case '2':
          return '下午'
        case '3':
          return '全天'
        default:
          return ''
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    toQueren(item) {
      if (!item.keepQuota) {
        this.$toast({
          message: '余号不足',
          position: 'top',
          duration: 500
        })
        return
      }
      if (item.isTrusted === true) return
      this.$router.push({ path: '/guahaoqueren', query: item })
    }
  }
}
</script>

<style scoped lang="less">
.timeCell-box{
  /deep/.van-cell__value {
    color: #fca237;
  }
  .item-status{
    border: 1px solid #2B8CFF;
    width: .4rem;
    height: .4rem;
    line-height: .4rem;
    text-align: center;
    border-radius: 50%;
    color: #2B8CFF;
    margin-right: .1rem;
    font-size: .12rem;
  }
}
</style>
